import environment from 'environment';
import crypto from 'crypto-browserify';
import { handleError } from 'services/ErrorService/ErrorService';

export const encryptUser = (userId) => {
  try {
    const hmac = crypto.createHmac('sha256', environment.intercom.intercomAppKey);
    hmac.update(userId);

    return hmac.digest('hex');
  } catch (error) {
    return handleError({
      error,
      customMessage: 'Error fetching intercom details for identity verification.',
    });
  }
};
